import { FC } from 'react'

import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded'
import { Button, Typography } from '@mui/material'

/** Small text-button header action that opens the corresponding full tab. */
export const ViewAllButton: FC<{ onClick: () => void; label: string }> = ({ onClick, label }) => (
  <Button
    size="small"
    variant="text"
    color="primary"
    onClick={onClick}
    endIcon={<ChevronRightRounded sx={{ fontSize: '1rem' }} />}
    sx={{
      textTransform: 'none',
      fontWeight: 700,
      flexShrink: 0,
      borderRadius: 999,
      px: 1,
      // Tighten the gap so the chevron reads as part of the label rather than
      // floating off to the right.
      '& .MuiButton-endIcon': { ml: 0.25 },
      '&:hover': { bgcolor: 'action.hover' },
    }}
  >
    {label}
  </Button>
)

/** Muted placeholder for an empty summary section. */
export const EmptyHint: FC<{ text: string }> = ({ text }) => (
  <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
    {text}
  </Typography>
)
